/**
 * [isEmpty Test if an object is empty]
 * @param  {Object}  object [The object to test]
 * @return {Boolean}
 */
export function isEmpty(object) {
    if (Object.keys(object).length === 0) {
        return true;
    }

    return false;
}